define("ROOM4.CCAWSwiperLoader.swiperDeferred", [], function () {
  "use strict";

  // Export a singleton Promise that can be resolved by the loader module.
  var resolveFn;
  var rejectFn;

  var deferred = new Promise(function (resolve, reject) {
    resolveFn = resolve;
    rejectFn = reject;
  });

  // Internal hooks for the loader to settle the promise.
  // Attaching methods is intentional so consumers can `require` the module
  // and use it directly as a Promise, while the loader can still resolve it.
  deferred["__resolve"] = function (value) {
    resolveFn && resolveFn(value);
    // Prevent double-resolution
    resolveFn = null;
    rejectFn = null;
  };
  deferred["__reject"] = function (error) {
    rejectFn && rejectFn(error);
    resolveFn = null;
    rejectFn = null;
  };

  return deferred;
});
